module.exports = __webpack_public_path__ + "static/img/service-ac-jogjakarta-2.81ba588.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kegiatan/service-ac-jogjakarta-2.jpg
// module id = /oPU
// module chunks = 0